import ManageCompanyContainer from './ManageCompanyContainer';

export default ManageCompanyContainer;
